import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";

type SendForReviewConfrmationModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const SendForReviewConfrmationModal = ({
  open,
  onClose,
  onConfirm,
}: SendForReviewConfrmationModalProps) => {
  return (
    <Modal.Root open={open} onOpenChange={onClose}>
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>Send for review?</Modal.Title>
          <Modal.Close />
        </Modal.Header>
        <Modal.Body>
          <div className="t-text-body-lg t-text-text-60">
            <div>
              The review will be sent as an action item in the chat, and once
              submitted for review, the financial closing cannot be edited.
            </div>
            <br />
            <p>Are you sure?</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="t-flex t-w-full t-container t-justify-end t-gap-2">
            <Button onClick={onClose} customType="secondary">
              Cancel
            </Button>
            <Button onClick={onConfirm} customType="primary">
              Send for review
            </Button>
          </div>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Root>
  );
};
